export var AdvertisingStatus;
(function (AdvertisingStatus) {
    AdvertisingStatus["Active"] = "active";
    AdvertisingStatus["Paused"] = "paused";
    AdvertisingStatus["Inactive"] = "inactive";
})(AdvertisingStatus || (AdvertisingStatus = {}));
